module.exports = __webpack_public_path__ + "img/ic_recognition.2f8e7893.png";